// Convert between epoch millis and an <input type="date"> value (YYYY-MM-DD).
// Dates are treated as UTC midnight to match Android's invoice date handling.
//
// First TypeScript file in the project — a pure leaf util used to validate the
// TS toolchain + TS<->JS interop. The rest of the codebase remains JS; CRA
// compiles both together (allowJs in tsconfig).

export function msToDateInput(ms: number): string {
  if (!ms) return "";
  const d = new Date(ms);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function dateInputToMs(str: string): number {
  if (!str) return 0;
  const [y, m, d] = str.split("-").map(Number);
  if (!y || !m || !d) return 0;
  return Date.UTC(y, m - 1, d);
}
